import * as React from 'react';
import { Row, Col, Statistic, Image, Card } from 'antd';

import Section from '../components/Section';
import Slideshow from '../components/Slideshow';

import cabin_2 from './media/cabin_2.jpg';
import cabin_3 from './media/cabin_3.jpg';
import cabin_4 from './media/cabin_4.jpg';
import cabin_5 from './media/cabin_5.jpg';
import cabin_6 from './media/cabin_6.jpg';
import cabin_8_10_12 from './media/cabin_8_10_12.jpg';
import cabin_9_11 from './media/cabin_9_11.jpg';
import cabins_top from './media/cabins_top.jpg';


export default function About() {

    var prices = (
        <Card title="Prisar" bordered={false} style={{ margin: "15px 5px" }}>
            <Row gutter={[16,32]}>
                <Col xs={12} lg={6}><Statistic title="Hytte 2" value="570,-" /></Col>
                <Col xs={12} lg={6}><Statistic title="Hytte 3, 4, 5, 6" value="600,-" /></Col>
                <Col xs={12} lg={6}><Statistic title="Hytte 8, 10, 12" value="750,-" /></Col>
                <Col xs={12} lg={6}><Statistic title="Hytte 9, 11" value="950,-" /></Col>
            </Row>
        </Card>
    );

    return (
        <Section id="cabins" title="Hytter">
            <Row gutter={16}>
                <Col lg={12}>
                    <p>Vi har 10 hytter i ulik størrelse og standard. Alle hyttene har kjøleskap og kokeplater. Det er ikkje dyner, puter eller sengkle i hyttene, men dyner og puter kan leigast. Vi har engangssengekle til salgs.</p>
                    <p>Hytte 2-6 er enkle eitromshytter for intill 4 personar. Hyttene har køysenger/familiekøye, kokeplate og kjøleskap, men er utan innlagt vatn. Dei ligg nær sanitæranlegget.</p>
                    <p>Hytte 8-12 har adskilt soverom for 2-3 personar, samt køyseng i opphaldsrom. Kjøkkenkrok med innlagt vatn. Bad med dusj og toalett på hytte 9 og 11.</p>
                    <Row>
                        <Col xs={0} lg={24}>
                            <Image src={cabins_top} preview={false} />
                        </Col>
                    </Row>
                </Col> 
                <Col lg={12}>
                    <Slideshow images={[cabin_2, cabin_3, cabin_4, cabin_5, cabin_6, cabin_8_10_12, cabin_9_11]} />
                    {prices}
                </Col>
            </Row>
            


            
        </Section>
    );
}